import React from 'react';

import { GetAdminResponse } from 'Api/CRM/Responses/AdminResponse';
import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';
import { IS_CASINO_ENABLED } from 'crm/helpers/Constants';

function AffiliateOwnerDetails({ affiliateOwner }: Readonly<{ affiliateOwner: GetAdminResponse }>) {
    return (
        <Card title="Affiliate Owner details">
            <TableDetailsBody>
                <Row label="ID">{affiliateOwner.id}</Row>
                <Row label="Name">{affiliateOwner.name}</Row>
                <Row label="Email">{affiliateOwner.email}</Row>
                <Row label="Country">{affiliateOwner.country}</Row>
                <Row label="State">{affiliateOwner.state}</Row>
                <Row label="Affiliate revenue (default commission)">{affiliateOwner.aff_percent_revenue ?? 0}%</Row>
                <Row label="Affiliate revenue (GGR commission)">{affiliateOwner.ggr_aff_percent_revenue ?? 0}%</Row>
                <Row label="Casino affiliate revenue" showIf={IS_CASINO_ENABLED}>
                    {affiliateOwner.casino_aff_percent_revenue ?? 0}%
                </Row>
            </TableDetailsBody>
        </Card>
    );
}

export default AffiliateOwnerDetails;
